import React from "react";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import RocketLaunchRoundedIcon from "@mui/icons-material/RocketLaunchRounded";

export default function StepFooter({
  step,
  lastStep,
  onBack,
  onNext,
  onSubmit,
  nextLabel,
  saving = false,
}) {
  const isLast = step === lastStep;

  return (
    <>
      <Divider sx={{ borderColor: "rgba(255,255,255,0.08)" }} />
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", md: "center" }}
        gap={1.4}
      >
        <Box>
          <Typography sx={{ fontWeight: 900, fontSize: 14 }}>
            {isLast ? "Última checagem antes de publicar" : `Próxima etapa: ${nextLabel || "Continuar"}`}
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.55)", fontSize: 12.5 }}>
            {isLast
              ? "Revise tudo com calma para evitar ajustes depois do evento publicado."
              : "Você pode avançar mantendo o mesmo comportamento do fluxo atual."}
          </Typography>
        </Box>

        <Stack direction="row" spacing={1.2} sx={{ width: { xs: "100%", md: "auto" } }}>
          <Button
            fullWidth
            variant="outlined"
            onClick={onBack}
            disabled={step === 0 || saving}
            startIcon={<ArrowBackRoundedIcon />}
            sx={{
              minHeight: 46,
              borderRadius: 2,
              fontWeight: 900,
              borderColor: "rgba(255,255,255,0.12)",
            }}
          >
            Voltar
          </Button>

          {!isLast ? (
            <Button
              fullWidth
              variant="contained"
              onClick={onNext}
              disabled={saving}
              endIcon={<ArrowForwardRoundedIcon />}
              sx={{
                minHeight: 46,
                borderRadius: 2,
                fontWeight: 900,
                background:
                  "linear-gradient(135deg, rgba(0,225,255,0.95), rgba(109,255,178,0.95))",
                color: "#042014",
                boxShadow: "0 14px 40px rgba(0,225,255,0.18)",
                "&:hover": {
                  opacity: 0.96,
                  boxShadow: "0 16px 42px rgba(0,225,255,0.24)",
                },
              }}
            >
              Próximo
            </Button>
          ) : (
            <Button
              fullWidth
              variant="contained"
              onClick={onSubmit}
              disabled={saving}
              endIcon={<RocketLaunchRoundedIcon />}
              sx={{
                minHeight: 46,
                borderRadius: 2,
                fontWeight: 900,
                background:
                  "linear-gradient(135deg, rgba(0,225,255,0.95), rgba(109,255,178,0.95))",
                color: "#042014",
                boxShadow: "0 14px 40px rgba(0,225,255,0.18)",
                "&:hover": {
                  opacity: 0.96,
                  boxShadow: "0 16px 42px rgba(0,225,255,0.24)",
                },
              }}
            >
              {saving ? "Salvando..." : "Salvar evento"}
            </Button>
          )}
        </Stack>
      </Stack>
    </>
  );
}
